import React from 'react';
import { formatTimestamp } from '@/lib/utils';
import { Terminal, Shield, Cpu, RefreshCw } from 'lucide-react';

interface FooterProps {
  lastSyncTime?: string | number | null;
  serverTime?: string | null;
  uptime?: string | number | null;
}

export const Footer: React.FC<FooterProps> = ({
  lastSyncTime,
  uptime,
}) => {
  return (
    <footer className="border-t border-[var(--border-default)] bg-[var(--footer-bg)] px-4 lg:px-6 py-2.5 text-[11px] font-mono text-[var(--text-muted)]">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-2">
        <div className="flex items-center gap-4 flex-wrap">
          <div className="flex items-center gap-1.5 text-[var(--text-secondary)]">
            <Terminal className="w-3.5 h-3.5 text-[var(--accent-primary)]" />
            <span>SWING & DELIVERY STOCK BOT DASHBOARD</span>
          </div>
          <div className="flex items-center gap-1 text-[var(--text-dim)]">
            <Shield className="w-3 h-3 text-[var(--accent-secondary)]" />
            <span>Read-Only Terminal</span>
          </div>
        </div>

        <div className="flex items-center gap-4 text-[var(--text-dim)]">
          {uptime && (
            <div className="flex items-center gap-1">
              <Cpu className="w-3 h-3" />
              <span>Uptime: {uptime}</span>
            </div>
          )}
          <div className="flex items-center gap-1">
            <RefreshCw className="w-3 h-3 text-[var(--text-dim)]" />
            <span>Last Sync: {lastSyncTime ? formatTimestamp(lastSyncTime, 'time') : '—'}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
